import { useQuery } from "react-query";
import { CustomModal, CustomView } from "../../../../../../components";
import Context from "../../../../../../context";
import api from "../../../../../../api";
import React from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";

const UserInfo = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, selectedDebt } = React.useContext(
    Context.DebtScreen
  );

  const { t } = useTranslation();

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             driver
  // !! ===========================================================================================================

  const driverResult = useQuery(["driver_info", selectedDebt], () =>
    api.post.company.findDriver({
      search: { base: "PHONE_NUMBER", value: selectedDebt.driverPhoneNumber },
    })
  )?.data?.result[0];
  const driverInfo = [
    {
      name: t("driverName"),
      value: driverResult?.firstName + " " + driverResult?.lastName,
    },
    {
      name: t("driverPhoneNumber"),
      value: driverResult?.phoneNumber,
    },
    // {
    //   name: "کدملی",
    //   value: driverResult?.companyInformation?.nationalCode,
    // },
    {
      name: t("cardNumber"),
      value: driverResult?.financial?.kartNumber,
    },
    {
      name: t("shabaNumber"),
      value: driverResult?.financial?.shabaNumber,
    },
  ];

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  console.log(selectedDebt);

  return (
    <CustomModal
      onClose={() => {
        setShowModal!("NONE");
        // setFormData({});
        // setStep(1);
      }}
      open={showModal === "SHOW_DEBT_USER_INFO"}
      minWidth={"40vw"}
      maxWidth={"45vw"}
    >
      <>
        <h6>{t("userInfo")}</h6>
        <div style={{ width: "100%" }}>
          <CustomView.Row className="form-column-row">
            {driverInfo?.map((item: any) => (
              <CustomView.Column medium={5} className="form-values form-column">
                <label className="form-label">{item?.name} :</label>
                <p>{item?.value}</p>
              </CustomView.Column>
            ))}
            <CustomView.Column medium={2} className="form-values form-column">
              <label className="form-label">{t("factorsCount")} :</label>
              {selectedDebt?.count}
            </CustomView.Column>
            <CustomView.Column medium={8} className="form-values form-column">
              <label className="form-label">{t("factorId")} :</label>
              <p>
                {selectedDebt?.trackingCode?.map(
                  (item: string, index: number) => (
                    <>
                      <span>{item}</span>{" "}
                      {index + 1 === selectedDebt?.trackingCode?.length
                        ? ""
                        : "-"}
                    </>
                  )
                )}
              </p>
            </CustomView.Column>
          </CustomView.Row>
        </div>
        {/* {status === "success" && data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={page}
              totalPages={data?.result?.totalPages}
              onPaginate={(page: number) => setPage(page)}
            />
          </div>
        )} */}
      </>
    </CustomModal>
  );
};

export default UserInfo;
